<template>
  <!-- region 面包屑 -->
  <ol class="breadcrumb">
    <li v-for="{onClick, label} in breadcrumb"
        @click="onClick && onClick.bind(vm)()"
        :class="onClick ? 'pointer' : ''"
    >{{label}}
    </li>
  </ol>
  <!-- endregion 面包屑 -->
</template>

<script>
export default {
  name: 'bread-crumb',
  props: {
    breadcrumb: {
      type: Array,
      required: true
    },
  },
  data () {
    return {
      vm: this
    }
  }
}
</script>

<style scoped lang="less">
  @import "../../styles/fun_var";

  .breadcrumb {
    border-bottom: 1px solid #E6EBF2;
    padding: 5px 0;
    border-radius: 0;
    background-color: #FFFFFF;
  }

  li.pointer:hover {
    color: @text-hover-color;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/di-ding/common/bread-crumb.vue